import { format as dateFnsFormat, isValid, parseISO, parseJSON, differenceInDays, } from 'date-fns';
export const format = (input, format = 'datetime') => {
    const date = (typeof input === 'string') ? parse(input) : input;
    if (format === 'date') {
        return formatDate(date);
    }
    if (format === 'datetime') {
        return `${formatDate(date)} ${formatTime(date)}`;
    }
    if (format === 'dayOfTheWeek') {
        return dateFnsFormat(date, 'EEEE');
    }
    if (format === 'time') {
        return formatTime(date);
    }
    if (format === 'database') {
        return dateFnsFormat(date, 'yyyy-MM-dd hh:mm:ss');
    }
    return dateFnsFormat(date, format);
};
const formatDate = (date) => dateFnsFormat(date, 'MM/dd/yyyy');
const formatTime = (date) => dateFnsFormat(date, 'h:mm aaa');
export const parse = (dateString) => parseISO(dateString);
export const isDate = (input) => typeof input === 'string' && isValid(parseJSON(input)); // eslint-disable-line @typescript-eslint/no-explicit-any
export { differenceInDays };
export * from './types.js';
//# sourceMappingURL=index.js.map